<template>
    <div class="cooperate">
        <myhead id="cooperatein_1" :param="param"/>
        <div>
        <section>
            <img :src="topimg" style="width: 100%;display: block;"/>
            <div  style="position: absolute;top:350px;left: 640px;"  >
                <div style="text-align: center">
                    <div style="font-size: 65px;font-weight: bold;margin-top: 12px;color: rgba(255,255,255,1)">人人可做合伙人</div>
                    <div style="font-size: 40px;margin-top: 12px;color: rgba(255,255,255,1)">无需学历、经验、资金也可轻松挣钱</div>
                </div>
            </div>
        </section>
        <section id="cooperatein_2">
            <div class="body100b" style="">
                <div style="position: relative;">
                    <div style="position: absolute;width: 100%;margin-top: 30px;">
                        <div class="box" style="text-align: center;font-size: 20px;">
                            <div class="child1" style="width: calc(50% - 100px);text-align: right">
                                <a class="mgd"
                                   @click="goto('/cooperate',{id:'2'})">邀请函</a>
                            </div>
                            <div class="child1" style="min-width: 200px;"></div>
                            <div class="child1" style="width: calc(50% - 100px);text-align: left">
                                <span style="border-bottom:2px solid red;padding-bottom: 20px;">加盟入口</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <img :src="gl01" style="width: 100%">
                    </div>
                </div>
            </div>
        </section>
            <section>
                <div class="body1660"
                     style="position:relative;margin-top: -100px;background-color: white;padding:24px 24px 0 24px ;min-height: 1000px;">

                </div>
            </section>

            <section>
                <div style="min-height: 80px"></div>
            </section>
        </div>
    </div>
</template>

<script>
    import myhead from '../components/myhead.vue'
    export default {
        name: "swbody",
        components: {
            myhead,
        },
        data() {
            return {
                param: {
                    pageindex: 6,
                    menuClickleft: (6-1)*120+30,
                    menuClickShow:'',
                },
                topimg: require('../assets/banner6.jpg'),
                gl01: require('../assets/gl-01.jpg'),
                sw01: require('../assets/sw-01.jpg'),

                swb01: require('../assets/sw-b01.png'),
                swb02: require('../assets/sw-b02.png'),
                swb03: require('../assets/sw-b03.png'),
                swb04: require('../assets/sw-b04.png'),
                swb05: require('../assets/sw-b05.jpg'),
                swys11: require('../assets/sw-ys11.jpg'),
                swys12: require('../assets/sw-ys12.jpg'),
                swys21: require('../assets/sw-ys21.jpg'),
                swys22: require('../assets/sw-ys22.jpg'),
                swys31: require('../assets/sw-ys31.jpg'),
                swys32: require('../assets/sw-ys32.jpg'),
                swys41: require('../assets/sw-ys41.jpg'),
                swys42: require('../assets/sw-ys42.jpg'),
                swbc01: require('../assets/sw-bc01.jpg'),
                swbc02: require('../assets/sw-bc02.png'),

                swlx01: require('../assets/sw-lx01.png'),
                swlx02: require('../assets/sw-lx02.png'),
                /*swlx03: require('../assets/sw-lx03.png'),*/


            }
        },
        mounted(){

        /*},
        update(){*/
            let id=this.$route.query.id
            if (!id) id=1
            document.getElementById('cooperatein_'+id).scrollIntoView();
        },
        methods: {
            goto(url,query) {
                this.$router.push({ path: url, query: query });
            },
        },
    }
</script>

<style lang="css" scoped>
    .cooperate {
        position: static;
        width: 100%;
        text-align: center;
    }
    .mgd {
        cursor:pointer;
    }
    .mgd:hover {
        background-color: rgba(203,203,203,1);
        color: rgba(24,24,24,0.9);
        border-radius: 5px;
    }
</style>
